module.exports = __webpack_public_path__ + "media/components/participants_visible_icon/static/Shape-9060995a98f54fd7645c3459f46b5099.png";